import { useCallback } from 'react';
import { useApiClient } from '../../../api';
import { prependApiHost } from '../../../../utils/urls';
import { isValidUrl } from '../../../../utils/urlUtils';
import { downloadLink } from '../../../../utils/downloadFile';

export default function useDownload() {
  const client = useApiClient({});

  const download = useCallback(
    async (url: string) => {
      if (!url) return;
      const filename = url.split('/').pop();
      if (!filename) return;

      if (url && isValidUrl(url)) {
        // if the url external do not download through the client to prevent
        // leaking JWTs
        downloadLink(url, filename);
        return;
      }

      const fullURL = prependApiHost(url);
      if (!fullURL) return;
      // download files from frontend-resources through the client to
      // provide the JWT
      const { data } = await client.get(fullURL, { responseType: 'blob' });
      const reader = new window.FileReader();
      reader.readAsDataURL(data);
      reader.onload = () => {
        if (reader.result) {
          downloadLink(reader.result as string, filename);
        }
      };
    },
    [client],
  );

  return {
    download,
  };
}
